import * as menuConstants from "../../../constants/menuConstants";
import * as objectTypes from "../../../constants/objectTypes";
import * as propertyConstants from "../../../constants/propertyConstants";

import React, { FunctionComponent, useEffect, useState } from "react";

import { DataItem } from "../../../types/dataItem";
import { MenuItem } from "../../../types/menu";
import { OptionItem } from "../../../types/optionItem";
import { PrivilegeItem } from "../../../types/privilegeItem";
import { PropsType } from "../../../containers/scenes/system/SystemColorantSceneContainer";
import { ResizingLayoutSceneContainer } from "../ResizingLayoutScene";
import { SystemColorantPackageTable } from "./tables/SystemColorantPackageTable";
import { SystemColorantTable } from "./tables/SystemColorantTable";

type Props = PropsType;

export const SystemColorantScene: FunctionComponent<Props> = ({ ...props }) => {
    const [tableColorants, setTableColorants] = useState<MenuItem | DataItem | OptionItem | PrivilegeItem | null>(
        (props.menuScene
            ? props.menuScene.items.find(
                  (item: MenuItem | DataItem | OptionItem | PrivilegeItem) => item.key === props.colorantTableConstant
              )
            : null) ?? null
    );
    useEffect(() => {
        setTableColorants(
            (props.menuScene
                ? props.menuScene.items.find(
                      (item: MenuItem | DataItem | OptionItem | PrivilegeItem) =>
                          item.key === props.colorantTableConstant
                  )
                : null) ?? null
        );
    }, [props.menuScene, props.colorantTableConstant]);

    const [tablePackages, setTablePackages] = useState<MenuItem | DataItem | OptionItem | PrivilegeItem | null>(
        (props.menuScene
            ? props.menuScene.items.find(
                  (item: MenuItem | DataItem | OptionItem | PrivilegeItem) =>
                      item.key === props.colorantPackageTableConstant
              )
            : null) ?? null
    );
    useEffect(() => {
        setTablePackages(
            (props.menuScene
                ? props.menuScene.items.find(
                      (item: MenuItem | DataItem | OptionItem | PrivilegeItem) =>
                          item.key === props.colorantPackageTableConstant
                  )
                : null) ?? null
        );
    }, [props.menuScene, props.colorantPackageTableConstant]);

    const getColorantsTable = (): JSX.Element | null => {
        if (tableColorants) {
            return (
                <SystemColorantTable
                    tableConstant={props.colorantTableConstant}
                    objectType={objectTypes.SYSTEM_COLORANT}
                    dataPrivileges={tableColorants}
                    priceDataPrivileges={props.priceDataPrivileges}
                    loading={props.colorantLoading}
                    buttonLoading={props.colorantButtonLoading}
                    allList={props.colorantList}
                    activeList={props.colorantActiveList}
                    availableCount={props.colorantAvailableCount}
                    columnOrder={props.colorantColumnOrder}
                    columnVisibility={props.colorantColumnVisibility}
                    columnWidth={props.colorantColumnWidth}
                    offset={props.colorantOffset}
                    page={props.colorantPage}
                    rowCount={props.colorantRowCount}
                    rowCountCustom={props.colorantRowCountCustom}
                    search={props.colorantSearch}
                    searchParams={props.colorantSearchParams}
                    showFilterRow={props.colorantShowFilterRow}
                    showGlobalSearch={props.colorantShowGlobalSearch}
                    sortingAsc={props.colorantSortingAsc}
                    sortingCriterion={props.colorantSortingCriterion}
                    totalCount={props.colorantTotalCount}
                    useTmcNames={props.optionUseTmcNames || false}
                    currency={props.currency}
                    optionPriceDefinition={props.optionPriceDefinition?.[propertyConstants.PROPERTY_VALUE] || null}
                    optionPriceEnableCompanyCost={
                        props.optionPriceEnableCompanyCost?.[propertyConstants.PROPERTY_VALUE] || false
                    }
                    optionPriceEnablePriceGroups={
                        props.optionPriceEnablePriceGroups?.[propertyConstants.PROPERTY_VALUE] || false
                    }
                />
            );
        }
        return null;
    };

    const getColorantPackagesTable = (): JSX.Element | null => {
        if (tablePackages) {
            return (
                <SystemColorantPackageTable
                    tableConstant={props.colorantPackageTableConstant}
                    objectType={objectTypes.SYSTEM_COLORANT_PACKAGE}
                    dataPrivileges={tablePackages}
                    loading={props.colorantPackageLoading}
                    buttonLoading={props.colorantPackageButtonLoading}
                    colorantActiveList={props.colorantActiveList}
                    unitList={props.unitList}
                    allList={props.colorantPackageList}
                    activeList={props.colorantPackageActiveList}
                    availableCount={props.colorantPackageAvailableCount}
                    columnOrder={props.colorantPackageColumnOrder}
                    columnVisibility={props.colorantPackageColumnVisibility}
                    columnWidth={props.colorantPackageColumnWidth}
                    offset={props.colorantPackageOffset}
                    page={props.colorantPackagePage}
                    rowCount={props.colorantPackageRowCount}
                    rowCountCustom={props.colorantPackageRowCountCustom}
                    search={props.colorantPackageSearch}
                    searchParams={props.colorantPackageSearchParams}
                    showFilterRow={props.colorantPackageShowFilterRow}
                    showGlobalSearch={props.colorantPackageShowGlobalSearch}
                    sortingAsc={props.colorantPackageSortingAsc}
                    sortingCriterion={props.colorantPackageSortingCriterion}
                    totalCount={props.colorantPackageTotalCount}
                    useTmcNames={props.optionUseTmcNames || false}
                />
            );
        }
        return null;
    };

    return (
        <ResizingLayoutSceneContainer
            tables={
                [getColorantsTable(), getColorantPackagesTable()].filter((item) => item !== null) as Array<JSX.Element>
            }
            layout={props.sceneLayout}
            dataPrivileges={tableColorants}
            sceneTableSize={props.colorantSceneTableSize}
            sceneConstant={menuConstants.PAGE_SYSTEM_COLORANTS}
        />
    );
};
